export class SummaryFetchFailedError extends Error {
	public constructor(public cause?: unknown) {
		super('Failed to fetch summary');
		this.name = 'SummaryFetchFailedError';
	}
}
